import { render, staticRenderFns } from "./SalesReportsPagination.vue?vue&type=template&id=d5b73f96&scoped=true"
import script from "./SalesReportsPagination.vue?vue&type=script&lang=js"
export * from "./SalesReportsPagination.vue?vue&type=script&lang=js"
import style0 from "./SalesReportsPagination.vue?vue&type=style&index=0&id=d5b73f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b73f96",
  null
  
)

export default component.exports